module.exports = __webpack_public_path__ + "img/bg-ls.efee7bac.png";